import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class ChangeStatusCreditCardApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/changeStatusCreditCard',
      requesterInfo,
    })
  }

  public async changeStatusCreditCard(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
